










































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { onMounted, ref } from "@vue/composition-api";
import { ReportTemplateSection } from "../data/pdf/model";

export default Vue.extend({
  components: { Modal },
  props: ["modalData"],
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "65rem",
      height: "55rem",
      withTopRightCloseBtn: true,
    };

    const displayed_sections = ref<ReportTemplateSection[]>([]);

    onMounted(() => {
      // @ts-ignore
      displayed_sections.value = props.modalData.sections;
    });

    return {
      config,
      displayed_sections,
    };
  },
});
